import React from 'react';
import { Link } from 'react-router-dom';
import { ReactTyped } from 'react-typed';
const Home = () => {
  return (
    <div className="bg-gray-900 text-white min-h-screen p-4">
      <div className="max-w-3xl mx-auto text-center py-20">
        <h1 className="text-4xl font-bold mb-6 text-[#00df9a]">
          Prior Protocol Testnet
        </h1>
        
        <div className="text-xl mb-8 h-10 flex items-center justify-center">
          <ReactTyped
            strings={[
              'Experience AI-powered DeFi on Base Network',
              'Automated Yield Optimization',
              'Cross-Chain Efficiency',
              'Community Governance'
            ]}
            typeSpeed={40}
            backSpeed={30}
            loop
          />
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link 
            to="/swap" 
            className="px-6 py-3 bg-[#00df9a] text-gray-900 font-medium rounded-lg hover:bg-[#00c78a] transition-colors"
          >
            Start Swapping
          </Link>
          <Link 
            to="/faucet" 
            className="px-6 py-3 border border-[#00df9a] text-[#00df9a] font-medium rounded-lg hover:bg-[#00df9a]/10 transition-colors"
          >
            Get Test Tokens
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Home;